export default __webpack_public_path__ + "static/media/utr.eac1f430.ttf";